export default __webpack_public_path__ + "static/media/uno-sound.5d88cef2.mp3";